<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="nav-bar box-horizontal mb-0">
            <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
            <div class="flex-1">
              <h3 class="m-0">Kang Tagih</h3>
              <p class="mb-0">Berikut List Kang tagih gan :)</p>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-3">
          <router-link :to="{ name: 'admin-tambah'}"  class="btn btn-primary" v-if="RootOnly()">Tambah Penagih</router-link>
        </div>
      </div>
      <div class="row" v-show="!isCari">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Daftar Penagih</h4>
                    <p class="card-category">Berikut daftar Penagih</p>
                  </div>
                  <div class="col-md-6">
                    <h2 class="card-title text-right">{{filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class="text-info">
                      <th width="30px">No.</th>
                      <th>Nama</th> 
                      <th>Pelanggan</th> 
                      <th>Belum</th> 
                      <th>Total Belum</th> 
                      <th>Sudah</th> 
                      <th>T. Sudah</th> 
                      <th>T. Pengeluaran</th> 
                      <th>T. Setor</th> 
                      <th>Total Uang</th> 
                      <th>Aksi</th> 
                    </thead>
                    <tbody v-show="loading">
                      <tr>
                        <td colspan="9"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="99"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="9"><Loading></Loading></td>
                      </tr>
                    </tbody>
                    <tbody v-show="!loading">
                      <tr v-for="(u, index) in admin">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</td> 
                        <td class="text-info text-center">{{ u.jumlah_pelanggan }}</td> 
                        <td class="text-info text-center"><router-link class="d-block link" :to="{ name: 'belum', params: { id:u.id, nama:u.nama}}">{{ u.belum_pelanggan }}</router-link></td> 
                        <td>{{ ribu(u.belum_bayar) }}</td> 
                        <td>{{ u.sudah_pelanggan }}</td> 
                        <td>{{ ribu(u.sudah_bayar) }}</td> 
                        <td>{{ ribu(isNull(u.pengeluaran)) }}</td> 
                        <td>{{ ribu(isNull(u.setor)) }}</td> 
                        <td>{{ ribu(parseInt(isNull(u.sudah_bayar)) - parseInt(isNull(u.pengeluaran)) )
                          }}</td> 
                        <td>
                          <router-link :to="{ name: 'admin-detail', params: { id: u.id, nama:u.nama  }}"  class="btn btn-sm btn-info"><i class="material-icons">remove_red_eye</i></router-link>
                          <router-link :to="{ name: 'admin-edit', params: { id: u.id, data:u  }}"  class="btn btn-sm btn-secondary" ><i class="material-icons">edit</i></router-link>
                          <button v-show="isAllow()" @click="modalHapus = true, idHapus = u.id, nmHapus = u.nama" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i></button>
                        </td> <!-- @click="hapusUser(index)" -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>
      <div class="row" v-show="isCari">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Daftar Penagih</h4>
                    <p class="card-category">Berikut daftar Penagih</p>
                  </div>
                  <div class="col-md-6">
                    <h2 class="card-title text-right">{{filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Paket</th>
                      <th>Area</th>
                      <th>Biaya</th>
                      <th>Aksi</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in pelangganCari">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.user.unama }}</br>{{ u.user.wa }}</td>
                        <td>{{ u.user.pnama }}</br>Tagihan Tgl {{ u.user.tanggal_tagihan }}</td>
                        <td>{{ u.area }}</td>
                        <td>{{ ribu(u.user.tarif) }}</td>
                        <td>
                          <router-link :to="{ name: 'pelanggan-detail', params: { id: u.user.uid, nama:u.user.unama, wa:u.user.wa, tgl:u.user.tanggal_tagihan, paket:u.user.pnama, bayar:u.user.ptarif, area:u.area  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i> Detail</router-link>

                          <button v-show="isAllow()" @click="showing = index, idHapus = u.user.uid" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Hapus</button>
                        </td>
                        <td>
                          <transition name="slide-fade" mode="out-in">
                            <button v-if="showing == index" v-show="showing == index" class="btn btn-sm btn-success slide-enter-active" @click="hapusUser(index)"><i class="material-icons">check_circle</i> Ya</button>
                          </transition>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>

      
			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="modalHapus">
          <div class="overlay"></div>
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Hapus</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalHapus = false">
                  <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="text-center">{{"Hapus Admin "+nmHapus+" ?"}}</p>
                    </div>
                  </div>
                </div>
								<div class="modal-footer">
									<button type="button" class="btn btn-info" @click="modalHapus = false">Tidak</button>
									<button type="button" class="btn btn-secondary" @click="hapusUser();modalHapus = false">Ya</button>
								</div>
            </div>
        </div>
    </div>
      

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import inter from '@/globalFunc/Interface' 
import mixin from '@/globalFunc/mixin' 
import Loading from '@/globalFunc/Loading' 
import myGlobal from '@/globalFunc/myGlobal' 

export default {
  name: 'Beranda', 
  components: {
    'Loading': Loading
  },
  data () {
    return {
      loading: true,
      admin: [],
      pelangganCari: [],
      cariByTelepon: false,
      
      showing: -1,
      telepon: '',
      dariTanggal: '',
      sampaiTanggal: '',
      statuse: '',
      filtered: '',

      // hapus
      idHapus: '',
      nmHapus: '',
      
      // cari kurir
      cariPelanggan: '',
      textCariPelanggan: '',
      textSalah: '',
      idPelanggan: '',
      namaPelanggan: '',

      // topup
      topup: '',
      password: '',


      // modal 
      modalTopup: false,
      preCari: true,

      isCari: false,
      modalHapus: false,

    }
  },
  methods: {
    simpanTopup() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('idPelanggan', this.idPelanggan);
      data.append('jumlah', this.topup);
      data.append('password', this.password);
      
      var apiUrl = 'TopupPelangganConfirmByTeller';
      this.PostData(data,apiUrl).then(x => {
        this.loger(x);
        if (x.status) {
          this.modalTopup = false;
          this.getData();
        } else {
          this.textSalah = x.pesan;
        }
      })
    },
    isNull(x) {
      var a;
      if (x == null) {
        a = 0;
      } else {
        a = x
      }
      return a;
    },
    hapusUser() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idHapus);
      
      var apiUrl = inter.AdminHapus();
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.getData();
          this.showing = -1;
        } else {
          //alert(x.pesan);
        }
      })

    },
    getData() {
      this.isCari = false;

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        bulan: sessionStorage.getItem('bulanIdBase'),
        tahun: sessionStorage.getItem('tahunBase')
      }

      //console.log(JSON.stringify(data));
      
      var apiUrl = inter.AdminListKangTagih();
      this.PostData(data,apiUrl).then(x => {
        
        //console.log(JSON.stringify(x));

        this.loading = false;
        if (x.status) {
          this.admin = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    }
  },
  mounted () {
    document.title = "List Admin";

    this.getData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.link {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/kangtagih/main.vue